(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/invite/dialogs.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/invite/dialogs.js');

'use strict';

const showConfirmInviteDialog = syndicateName => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'spela-tillsammans',
    title: "Vill du g\xE5 med i ".concat(syndicateName, "?"),
    actions: [{
      title: 'Nej tack',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Gå med i laget',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showWelcomeInviteDialog = syndicateName => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'spela-tillsammans',
    title: "V\xE4lkommen till ".concat(syndicateName, "!"),
    actions: [{
      title: 'Ok',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showUnavailableInviteDialog = errorText => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Denna inbjudan är inte giltig längre',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: errorText || 'Inbjudan kan ha återkallats eller redan blivit använd.'
    }],
    actions: [{
      title: 'Ok',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showInviteErrorDialog = errorText => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Kunde inte gå med i laget',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: errorText || 'Vänligen kontakta Kundservice om problemet kvarstår'
    }],
    actions: [{
      title: 'Ok',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.arena.pages.invite.dialogs = {
  showConfirmInviteDialog,
  showWelcomeInviteDialog,
  showInviteErrorDialog,
  showUnavailableInviteDialog
};

 })(window);